import { ChartOperation, ChartProgress, CHART_SIZE, EMPTY_PROGRESS, sanitizeProgress } from "./chartGame.ts";
import { Operations } from "../../MathFactsGenerator/Constants.ts";

/*
 * The chart game's saved progress (ADR 0054 §3). Local to the browser like
 * Shared/RecentWorksheets.ts: every access guarded, read after mount so the
 * prerendered HTML is the same for everyone, and nothing sent anywhere.
 *
 * Each chart keeps its own progress (ADR 0098 §2). The multiplication chart
 * keeps the key it has always had, so a half-filled chart survives the
 * addition chart arriving.
 */

const MULTIPLICATION_KEY = "mathpages.chartGame";
const ADDITION_KEY = "mathpages.chartGame.addition";

export function chartStorageKey(operation: ChartOperation = Operations.Multiplication): string {
    return operation === Operations.Addition ? ADDITION_KEY : MULTIPLICATION_KEY;
}

export function readChartProgress(operation: ChartOperation = Operations.Multiplication): ChartProgress {
    try {
        const stored = window.localStorage.getItem(chartStorageKey(operation));
        return stored ? sanitizeProgress(JSON.parse(stored), CHART_SIZE, operation) : EMPTY_PROGRESS;
    } catch {
        return EMPTY_PROGRESS;
    }
}

export function writeChartProgress(progress: ChartProgress, operation: ChartOperation = Operations.Multiplication): void {
    try {
        window.localStorage.setItem(chartStorageKey(operation), JSON.stringify(progress));
    } catch {
        // Full, disabled or unavailable: the chart still works for this visit.
    }
}

export function clearChartProgress(operation: ChartOperation = Operations.Multiplication): void {
    try {
        window.localStorage.removeItem(chartStorageKey(operation));
    } catch {
        // As above.
    }
}
